import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const token = localStorage.getItem("intenciv_token");

  useEffect(() => {
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("intenciv_token"); setUser(false); });
  }, [token]);

  const login = (tok, u) => {
    localStorage.setItem("intenciv_token", tok);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("intenciv_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
